// Renders a string with **bold** markers into React nodes (no HTML injection).
export function renderRich(text) {
  if (!text) return null;
  const parts = String(text).split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) => (i % 2 === 1 ? <b key={i}>{part}</b> : part));
}
